



































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { CheckoutStore } from '@/store/checkoutstate';
import { CheckoutModel, ModelState } from '@/models/Cart/Checkout';
 import { ApiService } from '@/services/ApiService';
// import { Spinner } from "spin.js";

@Component({
    components: {
        // DatePicker,
    },
})
export default class CustomerInformation extends Vue {
    // protected spinner: Spinner;
    // private deliveryCheckout: any[] = [];

    get cart() { return CheckoutStore.cart; }

    @Prop()
    protected model!: CheckoutModel;

    private viewmodelInternal!: CheckoutModel;

    protected requestContext: any;
    protected buttonIsPressed: boolean = false;
    protected isMounted: boolean = false;

    constructor() {
        super();
        this.requestContext = window.__litium.requestContext;
        // this.spinner = new Spinner({ scale: 0.5 });
        this.checkoutmodel = this.model;
        console.log(this.checkoutmodel);

        if  (this.checkoutmodel.customerDetails.address === null)
        {
            this.checkoutmodel.customerDetails.address = this.checkoutmodel.alternativeAddress.address
            this.checkoutmodel.customerDetails.zipCode = this.checkoutmodel.alternativeAddress.zipCode
            this.checkoutmodel.customerDetails.city = this.checkoutmodel.alternativeAddress.city
        }

        if  (this.checkoutmodel.customerDetails.phoneNumber === null)
        {
            this.checkoutmodel.customerDetails.phoneNumber = this.checkoutmodel.alternativeAddress.phoneNumber
        }

        console.log(this.checkoutmodel.customerDetails.email)
        console.log(this.checkoutmodel.alternativeAddress.email)
        console.log(this.checkoutmodel.notificationEmail)
        if  (this.checkoutmodel.customerDetails.email === null)
        {

            this.checkoutmodel.customerDetails.email = this.checkoutmodel.alternativeAddress.email;
        }
    }

    @Watch("cart.cartTotalExclDeliveryCost")
    cartTotalUpdated(newValue: string, oldValue: string) {
        console.log("cartTotalExclDeliveryCost");
         if (newValue !== oldValue) {
            console.log(newValue, oldValue);
            this.checkoutmodel = this.model;
         }
    }

    get checkoutmodel(): CheckoutModel {
        return this.viewmodelInternal;
    }

    set checkoutmodel(value: CheckoutModel) {
        this.viewmodelInternal = value;
    }

    get showFormErrorMessage(): boolean {
         var hasErrors = false;

        if (this.isMounted) {
            var observer = this.$refs.observer as any;
            if (observer) {
                for (var prop in observer.errors) {
                    if (Object.prototype.hasOwnProperty.call(observer.errors, prop)) {
                        var error = observer.errors[prop];
                        if (error.length > 0) {
                            hasErrors = true;
                            break;
                        }
                    }
                }
            }
         }

        return hasErrors;
    }

    mounted() {
        this.isMounted = true;

        console.log(this.checkoutmodel)
    }

    get currentLanguage(): string {
        return (document.querySelector("html") as HTMLElement).getAttribute("lang") as string;
    }

    public placeOrder() {
        console.log("PlaceOrder()")
    //     this.spinner.spin(this.$el as HTMLElement);
         this.buttonIsPressed = true;
         this.checkoutmodel.message = "";
         this.checkoutmodel.modelState = { general: [] as string[] } as ModelState;

         ApiService.checkoutOrder(this.checkoutmodel).then((response) => {
            console.log(response);
            
    //         this.spinner.stop();
             if (response && response.status == 200) {
                console.log(response.status);
                window.location.replace(response.data.redirectUrl);
             } else if (response && response.status == 400) {
                console.log(response.status);
                 var statusText = typeof (response.statusText) === "string" ? JSON.parse(response.statusText) : response.statusText;
                 this.checkoutmodel.message = statusText.message;
                 this.checkoutmodel.modelState = statusText.modelState;
             }  else if (response && response.status == 500) {
                console.log(response.status);
                 var statusText = typeof (response.statusText) === "string" ? JSON.parse(response.statusText) : response.statusText;
                 this.checkoutmodel.message = statusText.exceptionMessage;
             }
         });
    }
}
